import WorkoutExercise from './WorkoutExercise';

export default WorkoutExercise;
